
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Use relative path to handle sub-path deployments (e.g., in preview environments)
    navigator.serviceWorker.register('./service-worker.js')
      .then(registration => {
        console.log('PWA ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(err => {
        // Suppress error logging for SecurityError/origin mismatch which is common in cloud IDE previews
        if (err.name === 'SecurityError' || err.message.includes('origin')) {
           console.warn('PWA ServiceWorker registration skipped due to environment restrictions (likely a preview domain). This is expected in development.');
        } else {
           console.log('PWA ServiceWorker registration failed: ', err);
        }
      });
  });
}